/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 as Typography } from '@coursera/cds-core';

import RatingsBreakdown from 'bundles/unified-description-page-common/components/modules/reviews/RatingsBreakdown';

import _t from 'i18n!nls/reviews';

type RatingCountsByStar = {
  fiveStarRatingCount?: number | null;
  fourStarRatingCount?: number | null;
  threeStarRatingCount?: number | null;
  twoStarRatingCount?: number | null;
  oneStarRatingCount?: number | null;
};

type Props = {
  averageFiveStarRating?: number | null;
  ratingCount?: number | null;
  ratingCountsByStar?: RatingCountsByStar | null;
};

const styles = {
  card: css`
    background: var(--cds-color-neutral-background-primary);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: 20px;
    padding: var(--cds-spacing-300);
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const ReviewsRatingCard = ({ averageFiveStarRating, ratingCount, ratingCountsByStar }: Props) => {
  if (!ratingCount || !ratingCountsByStar) {
    return null;
  }

  return (
    <section css={styles.card} aria-labelledby="rating-title">
      <Typography variant="subtitleLarge" component="h2" css={styles.title} id="reviews-rating-title">
        {_t('Overall rating')}
      </Typography>
      <RatingsBreakdown
        averageFiveStarRating={averageFiveStarRating}
        ratingCount={ratingCount}
        ratingCountsByStar={ratingCountsByStar}
        useSingleLineCenteredSummary
      />
    </section>
  );
};

export type { RatingCountsByStar };

export default ReviewsRatingCard;
